import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "antd";
import { PlayCircleFilled, ExclamationCircleOutlined } from "@ant-design/icons";
import MenuPortal from "./MenuPortal";
import './portal.css';


//Imagenes 
import Requisito0 from '../../../assets/img/Requirements/requisitosIMG_00.svg';
import Requisito1 from '../../../assets/img/Requirements/requisitosIMG_01.svg';
import Requisito2 from '../../../assets/img/Requirements/requisitosIMG_02.svg';
import Requisito3 from '../../../assets/img/Requirements/requisitosIMG_03.svg';
import Requisito4 from '../../../assets/img/Requirements/requisitosIMG_04.svg';
import Requisito5 from '../../../assets/img/Requirements/requisitosIMG_05.svg';
import Requisito6 from '../../../assets/img/Requirements/requisitosIMG_06.svg';
import Requisito7 from '../../../assets/img/Requirements/requisitosIMG_07.svg';
import Requisito8 from '../../../assets/img/Requirements/requisitosIMG_08.svg';

const Requisitos = () => {
  function toTop() {
    window.scrollTo(0, 0);
}

  useEffect(() => {
    toTop();
  }, []);

  
  return (
    
    <div className="interioresPortal new-design">
      <Row  gutter={24}>
      <Col xxl={{ span: 3 }} xl={{ span: 3  }}>
      <Link to={"/"} className="button-back">
        <PlayCircleFilled rotate="180"/> Regresar
      </Link>
      </Col>
    
      <Col xxl={{ span: 21}} xl={{ span: 21}}>
      <MenuPortal active={'requisitos'} /></Col>
      </Row>

    <h1 className="main-title">Requisitos</h1>

    <Row  gutter={24} className="interioresPortal new-design descript-text" >
        <Col xxl={{ span: 18, offset: 3 }} xl={{ span: 18, offset: 3 }} lg={{ span: 18, offset: 3 }} md={{ span: 18, offset: 3 }} sm={24} xs={24}>
          <p>
            Todo el proceso de acreditación podrás llevarlo mediante el Portal de Observadoras y Observadores del Proceso Electoral, para ello deberás realizar lo siguiente:
          </p>
        </Col>
      </Row>

   
    <Row gutter={24} style={{ marginBottom: "80px" }} align="middle">
        <Col xxl={{ span: 8}} xl={{ span: 8 }} lg={{span: 8}} md={{ span: 8 }} sm={24} xs={24}>
          {/* <h2>¿Quién es una Observadora/or Electoral?</h2> */}
          <div className="imgCont">
            <img src={Requisito0} alt="requisito0" className="img-center apartadorequisitos"/>
          </div>
          <Row type="flex" justify="start">
          <Col span={24}>
            <div className="elementoLista">
            <ol>
              <li><strong>Ser ciudadana o ciudadano mexicano</strong></li>
              <p>Teniendo tu credencial de elector vigente.</p>
            </ol>           
            </div>
            </Col>
          </Row>
        </Col>

        <Col xxl={{ span: 8}} xl={{ span: 8 }} lg={{span: 8}} md={{ span: 8 }} sm={24} xs={24}>
          {/* <h2>¿Quién es una Observadora/or Electoral?</h2> */}
          <div className="imgCont">
            <img src={Requisito2} alt="requisito2" className="img-center apartadorequisitos"/>
          </div>
          <Row type="flex" justify="start">
          <Col span={24}>
            <div className="elementoLista">
            <ol >
              <li />
              <li ><strong>Registrarte para realizar tu solicitud de acreditación</strong></li>
              <p>El registro se lleva a cabo en línea, debes crear una cuenta y después llenar tu solicitud.</p>
            </ol>           
            </div>
            </Col>
          </Row>
        </Col>


        <Col xxl={{ span: 8}} xl={{ span: 8 }} lg={{span: 8}} md={{ span: 8 }} sm={24} xs={24}>
          {/* <h2>¿Quién es una Observadora/or Electoral?</h2> */}
          <div className="imgCont">
            <img src={Requisito1} alt="requisito1" className="img-center apartadorequisitos"/>
          </div>
          <Row type="flex" justify="start">
          <Col span={24}>
            <div className="elementoLista">
            <ol>
              <li />
              <li />
              <li><strong>Tomar el curso de capacitación</strong></li>
                {/* <p>Puede ser impartido en línea por el INE; o de manera presencial por el INE, Institutos Electorales de una entidad u organizaciones.</p> */}
                <p>Para la Jornada Electoral podrás tomar el curso de manera virtual, de manera presencial o a distancia a través de alguna herramienta o plataforma (Zoom, Google Meet, Microsoft Teams o algún otro).</p>
            </ol>           
            </div>
            </Col>
          </Row>
        </Col>
      </Row>


      <h2 className="sub-title"><ExclamationCircleOutlined style={{ marginBottom: "80px" }} /> No deberás estar en los siguientes casos:</h2>


      <Row gutter={24} align="middle">
        <Col xxl={{ span: 8}} xl={{ span: 8 }} lg={{span: 8}} md={{ span: 8 }} sm={24} xs={24}>
          {/* <h2>¿Quién es una Observadora/or Electoral?</h2> */}
          <div className="imgCont">
            <img src={Requisito3} alt="requisito3" className="img-center apartadorequisitos"/>
          </div>
          <Row type="flex" justify="start">
          <Col span={24}>
            <div className="elementoLista">
            <ol>
              <li><strong>Tener investigaciones judiciales o penales por algún delito</strong></li>
            </ol>           
            </div>
            </Col>
          </Row>
        </Col>

        <Col xxl={{ span: 8}} xl={{ span: 8 }} lg={{span: 8}} md={{ span: 8 }} sm={24} xs={24}>
          {/* <h2>¿Quién es una Observadora/or Electoral?</h2> */}
          <div className="imgCont">
            <img src={Requisito4} alt="requisito4" className="img-center apartadorequisitos"/>
          </div>
          <Row type="flex" justify="start">
          <Col span={24}>
            <div className="elementoLista">
            <ol >
              <li />
              <li ><strong>Ser o haber sido miembro de Organizaciones o Partidos Políticos*</strong></li>
            </ol>           
            </div>
            </Col>
          </Row>
        </Col>


        <Col xxl={{ span: 8}} xl={{ span: 8 }} lg={{span: 8}} md={{ span: 8 }} sm={24} xs={24}>
          {/* <h2>¿Quién es una Observadora/or Electoral?</h2> */}
          <div className="imgCont">
            <img src={Requisito5} alt="requisito5" className="img-center apartadorequisitos"/>
          </div>
          <Row type="flex" justify="start">
          <Col span={24}>
            <div className="elementoLista">
            <ol>
              <li />
              <li />
              <li><strong>Tener o haber tenido una candidatura a puesto de Elección Popular*</strong></li>
            </ol>           
            </div>
            </Col>
          </Row>
        </Col>
      </Row>


      <Row gutter={24}  align="middle">
      <Col xxl={{ span: 8}} xl={{ span: 8 }} lg={{span: 8}} md={{ span: 8 }} sm={24} xs={24}>
          {/* <h2>¿Quién es una Observadora/or Electoral?</h2> */}
          <div className="imgCont">
            <img src={Requisito6} alt="requisito6" className="img-center apartadorequisitos"/>
          </div>
          <Row type="flex" justify="start">
          <Col span={24}>
            <div className="elementoLista">
            <ol>
              <li />
              <li />
              <li />
              <li><strong>Ser designado como funcionaria o funcionario de casilla de la Jornada Electoral</strong></li>
            </ol>           
            </div>
            </Col>
          </Row>
        </Col>

        <Col xxl={{ span: 8}} xl={{ span: 8 }} lg={{span: 8}} md={{ span: 8 }} sm={24} xs={24}>
          {/* <h2>¿Quién es una Observadora/or Electoral?</h2> */}
          <div className="imgCont">
            <img src={Requisito7} alt="requisito7" className="img-center apartadorequisitos"/>
          </div>
          <Row type="flex" justify="start">
          <Col span={24}>
            <div className="elementoLista">
            <ol>
              <li />
              <li />
              <li />
              <li />
              <li><strong>Ser representante de Partido Político o Candidatura Independiente</strong></li>
            </ol>           
            </div>
            </Col>
          </Row>
        </Col>

        <Col xxl={{ span: 8}} xl={{ span: 8 }} lg={{span: 8}} md={{ span: 8 }} sm={24} xs={24}>
          {/* <h2>¿Quién es una Observadora/or Electoral?</h2> */}
          <div className="imgCont">
            <img src={Requisito8} alt="requisito8" className="img-center apartadorequisitos"/>
          </div>
          <Row type="flex" justify="start">       
          <Col span={24}>
            <div className="elementoLista">
            <ol>
              <li />
              <li />
              <li />
              <li />
              <li />
              <li><strong>Ser persona Servidora Pública:</strong></li>
                {/* <p>Puede ser impartido en línea por el INE; o de manera presencial por el INE, Institutos Electorales de una entidad u organizaciones.</p> */}
                <p>Vinculada con programas sociales en el gobierno municipal, estatal o federal, ni ser persona operadora de programas sociales y actividades institucionales, cualquiera que sea su denominación, ni persona servidora de la nación. (Acuerdo INE/CG535/2023). </p>
            </ol>           
            </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={24} align="middle">
        <Col xxl={{ span: 8}} xl={{ span: 8 }} lg={{span: 8}} md={{ span: 8 }} sm={24} xs={24}>
          {/* <h2>¿Quién es una Observadora/or Electoral?</h2> */}
          <div className="imgCont">
            <img src={Requisito4} alt="requisito4" className="img-center apartadorequisitos"/>
          </div>
          <Row type="flex" justify="start">
            <Col span={24}>
              <div className="elementoLista">
                <ol >
                  <li/>
                  <li/>
                  <li/>
                  <li/>
                  <li/>
                  <li/>
                  <li ><strong>No ser afiliado o militante de algún partido político.</strong></li>
                </ol>           
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row  gutter={24} className="interioresPortal new-design condicion" >
        <Col>
          <p>
          * Se consideran 3 años anteriores a la elección.
          </p>
        </Col>
      </Row>

  </div>
  );
};

export default Requisitos;
